// extracted by mini-css-extract-plugin
module.exports = {"message":"App-message-Doi-N"};